import { render } from "./MenuIcon.vue?vue&type=template&id=b24ab650&scoped=true"
import script from "./MenuIcon.vue?vue&type=script&lang=js"
export * from "./MenuIcon.vue?vue&type=script&lang=js"

import "./MenuIcon.vue?vue&type=style&index=0&id=b24ab650&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b24ab650"],['__file',"src/Components/ChatWidget/ChatIcons/MenuIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b24ab650"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b24ab650', __exports__)) {
    api.reload('b24ab650', __exports__)
  }
  
  module.hot.accept("./MenuIcon.vue?vue&type=template&id=b24ab650&scoped=true", () => {
    api.rerender('b24ab650', render)
  })

}


export default __exports__